export enum xAxisLabels {
  DAILY = 'Hours',
  MONTHLY = 'Days',
  YEARLY = 'Months',
}
